'use client'
import React from 'react'
import {Metadata} from 'next'
import ErrorContent from '../src/components/errors/ErrorContent'

export const metadata: Metadata = {
    title: 'Fehler aufgetreten | First Class Performance',
    description: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns direkt.',
    robots: {
        index: false,
        follow: false,
    },
}

export default function Error({
                                  error,
                                  reset,
                              }: {
    error: Error & {digest?: string}
    reset: () => void
}) {
    return (
        <>
            <ErrorContent error={error} reset={reset} />
        </>
    )
}
